import { ReactNode } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import CTA from "../sections/CTA";

interface PageLayoutProps {
  children: ReactNode;
  showCTA?: boolean;
  showFooter?: boolean;
  className?: string;
  contentClassName?: string;
}

const PageLayout = ({
  children,
  showCTA = false,
  showFooter = true,
  className = "",
  contentClassName = ""
}: PageLayoutProps) => {
  return (
    <div className={`min-h-screen bg-slate-900 text-white ${className}`}>
      <Navigation />
      
      <main className={contentClassName}>
        {children}
      </main>
      
      {showCTA && <CTA />}
      {showFooter && <Footer />}
    </div>
  );
};

export default PageLayout;
